import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const AI = () => {
  return (
    <StartInterviewLayout type="ai"/>
  )
}

export default AI;